import axios from "axios";
import { variables } from "../environments";

let config = {
  headers: {
    "Content-Type": "application/json",
    source: "pharmacyWeb",
    appVersionCode: variables.appVersionCode,
  },
};

const CURECOIN_URL = variables.CureCoinUrl;
const CHE_SERVICE_URL = variables.CheServiceUrl;
const CART_URL = variables.CartUrl;
const COIN_REDEMPTION_URL = variables.CoinRedemptionUrl;
const ADMIN_URL = variables.ADMIN_URL;
const COIN_REDEMPTION = variables.CoinRedemptionApiUrl;

const getToken = async () => {
  let token;
  let authData = localStorage.getItem("userAuth");
  let onBehalfRetCode = localStorage.getItem("onBehalfRetCode");
  let userData = localStorage.getItem("userData");
  userData = JSON.parse(userData);

  if (authData && JSON.parse(authData).data.jwtToken) {
    token = JSON.parse(authData).data.jwtToken;
  }
  config.headers.Authorization = "Bearer " + token;

  if (
    onBehalfRetCode &&
    onBehalfRetCode.length > 0 &&
    onBehalfRetCode !== "undefined" &&
    (userData.admin || userData.salesPerson)
  ) {
    config.headers.adminRetailerCode = onBehalfRetCode;
    config.headers.source = "pharmacyWebOnbehalf";
  }
  return true;
};

export const getAllPoints = async (patientId) => {
  return axios.get(`${CURECOIN_URL}/userwallet/getallpoints`, {
    params: { patientId },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const searchPatient = async (
  searchText,
  pageNumber = 1,
  pageSize = 20,
) => {
  return axios.get(`${CHE_SERVICE_URL}/patient/search`, {
    params: { searchText, pageNumber, pageSize },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const sendMobileOtp = async (data) => {
  return axios.post(`${CART_URL}/curecoin/mobile/otp`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const validateOtp = async (data) => {
  return axios.post(`${CART_URL}/curecoin/cheEngage/validate/otp`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const redeemPoints = async (data) => {
  return axios.post(`${CURECOIN_URL}/retail/redeem`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getRetailerLedgerBalance = async (retailerCode) => {
  await getToken();
  return axios.get(`${ADMIN_URL}/home/ledger/showRetailerLedgerBalanceAmount`, {
    headers: config.headers,
    params: { retailerCode },
  });
};

export const addCoinsOnRedemption = async ({
  retailerCode,
  invoiceNumber,
  amount,
}) => {
  await getToken();
  return axios.post(COIN_REDEMPTION, null, {
    ...config,
    params: { retailerCode, invoiceNumber, amount },
  });
};
